// @flow
import React from 'react';
import NuxSelectList from 'app/common/react/components/growth/activation/NuxLocaleCountryStep/NuxSelectList';

type DataType = {
  key: string,
  name: string,
};

type Props = {
  defaultOptions?: Array<DataType>,
  id: string,
  items: {
    data: Array<DataType>,
  },
  name?: string,
  onChange: ({ event: SyntheticInputEvent<>, value: string }) => void,
  value?: string,
};

const NuxAccountBasicsList = (props: Props) => {
  const { defaultOptions, id, items, name, onChange, value } = props;
  const options = (items.data || defaultOptions || [])
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(({ name, key }) => ({
      label: name.toString(),
      value: key,
    }));

  return <NuxSelectList id={id} name={name} onChange={onChange} options={options} value={value} />;
};

export default NuxAccountBasicsList;
